let loadPromise: Promise<typeof YT> | null = null;

export function loadYouTubeApi(): Promise<typeof YT> {
    if (window.YT?.Player) {
        return Promise.resolve(window.YT);
    }

    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise<typeof YT>((resolve) => {
        const script = document.createElement("script");
        script.src = "https://www.youtube.com/iframe_api";

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const win = window as any;
        const prevCallback = win.onYouTubeIframeAPIReady as (() => void) | undefined;

        win.onYouTubeIframeAPIReady = () => {
            prevCallback?.();
            resolve(window.YT);
        };

        document.head.appendChild(script);
    });

    return loadPromise;
}
